// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomModal_root__-rB_U","alertBox":"CustomModal_alertBox__2vXMn","grow":"CustomModal_grow__cgB-P","alertCross":"CustomModal_alertCross__1X4zT"};